<template>
  <RexModalV3
    :show="showGraphModal"
    width="80.625rem"
    :cancelButtonProps="{ style: { display: 'none' } }"
    :submitText="$t('close')"
    @onSubmit="$emit('closeGraphModal')"
    :headerStyle="{ borderBottom: 'none', padding: '0px', margin: '0px' }"
    :hideCloseIcon="true"
  >
    <template #header>
      <div></div>
    </template>
    <template #body>
      <div class="main-container">
        <Card :customStyle="{ height: 'auto', flex: '1' }" :header="title">
          <template #card-body>
            <div class="d-flex flex-column items-container">
              <div class="d-flex" v-for="(row, index) of data" :key="index">
                <RexTooltipV3
                  :title="row[legendHeaders[highLightColValue].key]"
                >
                  <div class="info-percent">
                    {{ row[legendHeaders[highLightColValue].key] }}
                  </div>
                </RexTooltipV3>
                <div
                  class="info-container"
                  :class="[row.label === selectedRow ? 'highlight' : '']"
                  :style="{
                    width: '100%',
                  }"
                >
                  {{ row[legendHeaders[infoSpanColIndex].key] }}
                </div>
              </div>
            </div>
          </template>
        </Card>
        <MultiLineChart
          :legendHeaders="legendHeaders"
          :item="item"
          :data="data"
          highLightColValue="1"
          :intervalTime="intervalTime"
          @openModal="showGraphModal = true"
          chartId="abc"
          :style="{ flex: 2 }"
          @selectedRow="selectRow"
          :insideModal="true"
          :title="title"
          @closeModal="$emit('closeGraphModal')"
          :formula="formula"
          :Graphlabels="Graphlabels"
          :secondaryResetIcon="true"
        />
      </div>
    </template>
  </RexModalV3>
</template>
<script>
import RexModalV3 from '@/rex-components/RexModalV3.vue';
import { onHide } from '@/utils/modal.common';
import MultiLineChart from '@/components/charts/multi-chart.vue';
import Card from '@/rex-components/rex-card.vue';
import RexTooltipV3 from '@/rex-components/RexTooltipV3.vue';
const { props } = MultiLineChart;
export default {
  emits: ['closeGraphModal'],
  components: { RexModalV3, MultiLineChart, Card, RexTooltipV3 },
  data() {
    return {
      showWindow: this.showGraphModal,
      selectedRow: '',
    };
  },
  props: {
    ...props,
    showGraphModal: { type: Boolean, default: false },
    infoSpanColIndex: { type: String, default: '' },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    onHide,
    selectRow(row) {
      this.selectedRow = row;
    },
  },
  mounted() {},
  watch: {
    showGraphModal(newVal) {
      this.showWindow = newVal;
      /**
       * This is important.
       * Again after strugling for hours..
       * There is a issue with current apex chart version : On opening modal, it doesn't paint itself unless someone manaully resize the modal window.
       * for more info look at : https://github.com/apexcharts/react-apexcharts/issues/187
       * Here we invoke a resize event whenever there is change in modal value
       */
      window.dispatchEvent(new Event('resize'));
    },
  },
};
</script>
<style scoped lang="scss">
.flex-2 {
  flex: 3;
}
.info-container {
  text-align: left;
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
  margin-bottom: 0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.side-bar-info {
  width: 10rem;
}
.main-container {
  display: flex;
  flex: 1 2;
  gap: 1rem;
  flex-direction: row;
}
.modal-lg {
  max-width: 1000px;
}
.info-percent {
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
  margin-bottom: 0.5rem;
  margin-right: 0.5rem;
  font-weight: bold;
  width: 5.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.highlight {
  background: rgba(173, 106, 0, 0.8) !important;
}
.items-container {
  height: 33rem;
  overflow: scroll;
}
.multi-chart-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: $color-black;
  opacity: 0.5;
  z-index: 199;
}
.multi-chart {
  z-index: 200;
}
</style>
